export default __webpack_public_path__ + "static/media/step1.9441cbf4.svg";